<template>
  <div class="area-confirm">
    <div class="area-confirm-shadow" @click="hidePopup"></div>
    <div class="area-confirm-main">
      <p class="main-title">{{ letter.areaLimitSwitchRegion }}</p>
      <div class="main-content">
        <template v-if="!havePayWay">
          <div class="main-tips">
            <p>{{ letter.noPayWay }}</p>
          </div>
        </template>
        <template v-else-if="isLocationDiff && !nextLocationName && canSwitch">
          <div class="main-tips">
            <p>{{ letter.areaLimitInconsistencyWarning }}</p>
            <p>{{ letter.areaLimitPromptToSwitch }}</p>
          </div>
        </template>
        <p class="main-content-title">
          {{ letter.areaLimitPreSwitchRegionCurrency }}
        </p>
        <template>
          <div class="main-box">
            <div class="box-area">
              <p>{{ letter.areaLimitRegion }}</p>
              <p class="text">{{ curLocationName }}</p>
            </div>
            <div class="box-area short" v-if="showCurZipCode">
              <p>zipcode</p>
              <p class="text">{{ zipCode }}</p>
            </div>
            <div class="box-area">
              <p>{{ letter.areaLimitCurrency }}</p>
              <p class="text">{{ defaultCurrency }}</p>
            </div>
          </div>
        </template>
        <template v-if="nextLocationName">
          <p class="main-content-title">
            {{ letter.areaLimitPostSwitchRegionCurrency }}
          </p>
          <div class="main-box active">
            <div class="box-area active">
              <p>{{ letter.areaLimitRegion }}</p>
              <p class="text">{{ nextLocationName }}</p>
            </div>
            <div class="box-area short active" v-if="showNextZipCode">
              <p>zipcode</p>
              <p class="text">{{ nextZipCode }}</p>
            </div>
            <div class="box-area active">
              <p>{{ letter.areaLimitCurrency }}</p>
              <p class="text">{{ nextCurrency }}</p>
            </div>
          </div>
        </template>
        <template v-if="showCurZipCode">
          <p class="main-box main-zipcode-btn" @click="goUpdateZipCode">
            {{ letter.zipCodeSwitchZipCode }}
          </p>
        </template>
        <div class="main-tips" v-if="!canSwitch">
          <p>{{ letter.areaLimitNoRemainingSwitches }}</p>
          <p>{{ letter.areaLimitUnableToSwitchThisYear }}</p>
        </div>
        <template v-if="!nextLocationName">
          <p>{{ letter.areaLimitNote }}</p>
          <p>{{ letter.areaLimitSwitchLimitationTwice }}</p>
          <p>{{ letter.areaLimitPostSwitchCoupon }}</p>
          <div class="main-btn-wrap">
            <a
              v-if="canSwitch"
              class="confirm btn"
              href="javascript:;"
              @click="showAreaSwitch('V2')"
            >
              {{ letter.areaLimitNavigateToSwitch }}
            </a>
            <a v-else class="disabled btn" href="javascript:;">{{
              letter.areaLimitCannotSwitch
            }}</a>
          </div>
        </template>
        <template v-else>
          <div class="main-btn-wrap">
            <a
              class="confirm btn"
              href="javascript:;"
              @click="confirmSwitchArea(gameId, 'V2')"
            >
              {{ letter.areaLimitConfirm }}
            </a>
          </div>
          <p class="main-tips main-btn-tips">
            {{
              letter.areaLimitRemainingSwitches.replace(
                '\${times}',
                modifyCount
              )
            }}
          </p>
        </template>
      </div>
      <a href="javascript:;" class="main-close" @click="hidePopup"></a>
    </div>
    <transition name="fade">
      <AreaSwitchPopup
        v-if="showAreaSwitchPopup"
        @hidePopup="cancelAreaSwitchPopup"
        @getAreaSwithInfo="getAreaSwithInfo"
        :zipCode="zipCode"
      ></AreaSwitchPopup>
    </transition>
  </div>
</template>

<script>
import AreaSwitchPopup from '@components/officialWebStore/paytype/AreaSwitchPopup';
import areaLimit from '@mixins/areaLimit';
import { mapState } from 'vuex';
export default {
  name: 'AreaConfirmPopup',
  mixins: [areaLimit],
  props: {
    havePayWay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount,
      currency: state => state.paytype?.show_currency,
      zipCode: state => state.zipCode,
      ipLocation: state => state.ipLocation,
      defaultCurrency: state => state.defaultCurrency
    }),
    canSwitch() {
      // 如果没有支付方式/最大切换次数大于0并且当前切换次数小于最大切换次数才可切换
      return (
        !this.havePayWay ||
        (this.maxLocationModifyCount &&
          this.locationModifyCount < this.maxLocationModifyCount)
      );
    },
    isLocationDiff() {
      return this.ipLocation && this.ipLocation != this.curLocationVal;
    },
    modifyCount() {
      return this.maxLocationModifyCount
        ? this.maxLocationModifyCount - this.locationModifyCount
        : 0;
    }
  },
  methods: {},
  components: {
    AreaSwitchPopup
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.area-confirm {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 660px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }
}

.main {
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  &-title {
    font-size: 26px;
    text-align: center;
    line-height: 86px;
    height: 86px;
    @include g-popup-title();
    border-radius: 10px 10px 0 0;
    margin: 0;
  }

  &-content {
    font-size: 24px;
    text-align: start;
    padding: 60px 32px;
    line-height: 1.5;
    margin-bottom: 140px;
  }

  &-content-title {
    font-size: 28px;
    line-height: 36px;
    font-weight: bold;
  }

  &-box {
    width: 595px;
    display: flex;
    margin: 28px auto;
    background-color: #f6f6f6;
    border-radius: 6px;
    border: solid 2px;
    border-color: #999999;

    .box-area {
      font-size: 22px;
      color: #5e6863;
      width: 50%;
      text-align: start;
      padding: 14px 22px;

      .text {
        font-size: 28px;
        color: $btnBg;
      }

      &.short {
        width: 25%;
      }
    }
    .box-area + .box-area {
      border-left: 2px solid #999999;
    }
  }

  &-zipcode-btn {
    margin-top: 0;
    justify-content: center;
    height: 45px;
    line-height: 45px;
    cursor: pointer;
  }

  &-tips {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    color: #d25f27;
    margin-bottom: 30px;
  }

  &-btn-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      width: 244px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 28px;
      color: #fff;
      border-radius: 10px;
      padding: 0 10px;
      cursor: pointer;
    }

    .confirm {
      background: $btnBg;
    }

    .disabled {
      background-color: #999999;
    }
  }

  &-btn-tips {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    text-align: center;
    margin: 0;
  }
}

.active {
  border-color: $borderActive !important;
}
</style>
